var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderbolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11467 13.5205L10.2168 2.52565C10.6838 1.61413 12 1.96283 12 2.99808V9.01052H17.0504C17.7679 9.01052 18.2255 9.81556 17.8853 10.4795L13.7832 21.4744C13.3162 22.3859 12 22.0372 12 21.0019V14.9895H6.94961C6.23207 14.9895 5.77448 14.1844 6.11467 13.5205Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbolt);
export default __webpack_public_path__ + "static/media/thunderbolt.4ef921a90354cd793d8cae13c04458f0.svg";
export { ForwardRef as ReactComponent };